import { Suspense } from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import Activities from "./pages/Activities";
import ActionsToFollow from "./pages/ActionsToFollow";
import ProtectedRoute from "./components/ProtectedRoute";
import Mainlayout from "./pages/Mainlayout";
import Unauthorized from "./pages/Unauthorized";
import Profile from "./pages/Profile";
// import Simulation from "./pages/agent/Simulation";
// import AgentDetail from "./pages/agent/AgentDetail";
import ActionsIntegration from "./pages/integration/ActionsIntegration";
import PublicAgentPage from "./pages/agent/PublicAgentPage";
import AgentNew from "./pages/agent/AgentNew";
import AgentEditNew from "./pages/agent/AgentEditNew";
import AgentNewAdd from "./pages/agent/AgentNewAdd";

const RoutesComponent = () => {
  const routes = useRoutes([
    {
      path: "/app",
      element: (
        <ProtectedRoute>
          <Mainlayout>
            <Suspense>
              <Outlet />
            </Suspense>
          </Mainlayout>
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <Activities />
            </ProtectedRoute>
          ),
        },
        {
          path: "activities",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <Activities />
            </ProtectedRoute>
          ),
        },
        {
          path: "actions-to-follow",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <ActionsToFollow />
            </ProtectedRoute>
          ),
        },
        {
          path: "profile",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <Profile />
            </ProtectedRoute>
          ),
        },
        {
          path: "agent",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <AgentNew />
            </ProtectedRoute>
          ),
        },
        {
          path: "agent/add",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <AgentNewAdd />
            </ProtectedRoute>
          ),
        },
        {
          path: "agent/:id/edit",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <AgentEditNew />
            </ProtectedRoute>
          ),
        },
        // {
        //   path: "/app/agent/public/:id",
        //   element: <PublicAgentPage />,
        // },
        {
          path: "actions",
          element: (
            <ProtectedRoute>
              <ActionsIntegration />
            </ProtectedRoute>
          ),
        },
        {
          path: "unauthorized",
          element: (
            <ProtectedRoute requiredRoles={["admin", "client"]}>
              <Unauthorized />
            </ProtectedRoute>
          ),
        },
        {
          path: "*",
          element: <Unauthorized />,
        },
        // {
        //   path: "kb-new/:id",
        //   element: (
        //     <ProtectedRoute requiredRoles={["admin", "client"]}>
        //       <AgentEditNew />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: "agent/:id",
        //   element: (
        //     <ProtectedRoute requiredRoles={["admin", "client"]}>
        //       <AgentDetail />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: "agent/simulation",
        //   element: (
        //     <ProtectedRoute requiredRoles={["admin", "client"]}>
        //       <Simulation />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: "dashboard/*",
        //   element: <Unauthorized />,
        // },
      ],
    },
    {
      path: "/public/agent/:id",
      element: <PublicAgentPage />,
    },
    {
      path: "/signin",
      element: <Signin />,
    },
    {
      path: "/signup",
      element: <Signup />,
    },
    {
      path: "*",
      element: <Navigate to="/signin" replace />,
    },
    {
      path: "/",
      element: <Navigate to="/signin" replace />,
    },
  ]);

  return routes;
};

export default RoutesComponent;
